module.exports = __webpack_public_path__ + "static/alineacion-9fbe23813441742744e5457a22de965b.png";